import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import { paths } from '@/config/paths';
import { useAgentById } from '@/hooks/use-agents';

const SUFFIX = ' | FDE Assistants';

const TITLE_MAP: Record<string, string> = {
  [paths.Login]: 'Sign In',
  [paths.Assistant]: 'Choose an Assistant',
  [paths.BestPracticesOverview]: 'Best Practices – Overview',
  [paths.BestPracticesUsers]: 'Best Practices – Users',
  [paths.BestPracticesTeams]: 'Best Practices – Teams',
  [paths.BestPracticesContactMethods]: 'Best Practices – Contact Methods',
  [paths.BestPracticesSchedules]: 'Best Practices – Schedules',
  [paths.BestPracticesFlexibleSchedules]: 'Best Practices – Flexible Schedules',
  [paths.BestPracticesNotificationRules]: 'Best Practices – Notification Rules',
  [paths.BestPracticesEscalationPolicies]: 'Best Practices – Escalation Policies',
  [paths.BestPracticesServices]: 'Best Practices – Services',
  [paths.BestPracticesAIOps]: 'Best Practices – AIOps',
  [paths.BestPracticesIW]: 'Best Practices – Incident Workflows',
  [paths.BestPracticesOptimizationChecks]: 'Best Practices – Optimization Checks',
  [paths.RuleSummary]: 'Rule Summary',
  [paths.Settings]: 'Settings',
};

export const TitleManager: React.FC = () => {
  const location = useLocation();
  const agentMatch = useMatch(paths.AssistantAgent);
  const agentId = agentMatch?.params?.agentId ?? null;
  const agent = useAgentById(agentId);

  useEffect(() => {
    let page: string;

    if (agentId) {
      page = agent?.name ?? 'Assistant';
    } else {
      page = TITLE_MAP[location.pathname] ?? 'FDE Assistants';
    }

    document.title = page === 'FDE Assistants' ? page : page + SUFFIX;
  }, [location.pathname, agentId, agent]);

  return null;
};
